import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { SntI18nService } from '@senet-uiverse/i18n';

import { SntApiService, SntServerErrorsService } from '../services';
import { dialogCloseRef, dialog } from '../dialog';

import { SNT_ORG_CONFIG } from './organization.token';

// ? Цей клас є абстрактним і слугує базовим класом для інших класів, які потребують доступу до глобальних методів та сервісів
export abstract class UniversalHelpersClass {
  readonly errorService = inject(SntServerErrorsService);
  readonly translateService = inject(TranslateService);
  readonly activatedRoute = inject(ActivatedRoute);
  readonly i18nService = inject(SntI18nService);
  readonly apiService = inject(SntApiService);
  readonly dialogCloseRef = dialogCloseRef();
  readonly cdRef = inject(ChangeDetectorRef);
  readonly destroyRef = inject(DestroyRef);
  readonly router = inject(Router);
  readonly dialog = dialog();

  readonly config = inject(SNT_ORG_CONFIG, { optional: true });
}
